module.exports = __webpack_public_path__ + "static/media/IMG-4.aa0fc0b0.jpg";